<script setup>
import format from 'string-format'
import { inject } from 'vue'
import Toastify from 'toastify-js'

const t = inject('t')

function share(type) {
  const loc = window.location
  const url = `${loc.protocol}//${loc.host}`
  if (type === 'whatsapp') {
    shareWhatsApp()
  } else if (type == 'email') {
    shareEmail()
  } else if (type == 'copy') {
    copyToClipboard()
  } else if (type == 'facebook') {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`)
  }
}

function printPage() {
  window.print()
}

function copyToClipboard() {
  const loc = window.location
  const url = `${loc.protocol}//${loc.host}`
  navigator.clipboard.writeText(url)
  Toastify({
    text: t('link-to-clipboard-result'),
    duration: 3000,
    gravity: 'bottom',
    position: 'center',
    style: {
      background: 'var(--color-signal)',
      color: '#fff'
    }
  }).showToast()
}

function shareEmail() {
  const loc = window.location
  const url = `${loc.protocol}//${loc.host}`
  const body = format(t('result-email-body'), url)
  const subject = format(t('email-result-subject'))
  window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`)
}

function shareWhatsApp() {
  const loc = window.location
  const url = `${loc.protocol}//${loc.host}`
  const body = format(t('result-whatsapp-body'), url)
  window.open(`https://wa.me/?text=${encodeURIComponent(body)}`)
}
</script>
<template>
  <section class="no-print">
    <div class="some">
      <h3>{{ t('share-title') }}</h3>

      <div class="buttons">
        <button class="share whatsapp" @click="share('whatsapp')">
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="21.3322" cy="21.4322" r="20.5322" stroke="#E2001A" stroke-width="1.2" />
            <path
              d="M22.0138 8.33325C15.5902 8.33325 10.3609 13.558 10.3586 19.9817C10.3574 22.035 10.8952 24.0396 11.9149 25.8059L10.3335 31.6666L16.438 30.2242C18.1402 31.1529 20.0563 31.6404 22.007 31.6415H22.0116C28.4341 31.6415 33.6611 26.4156 33.6646 19.9931C33.6669 16.8792 32.456 13.9516 30.2557 11.7489C28.0554 9.54744 25.1312 8.33442 22.0138 8.33325ZM22.0116 10.6666C24.5036 10.6678 26.8455 11.6393 28.606 13.3987C30.3665 15.1603 31.3336 17.5011 31.3312 19.9908C31.3289 25.1288 27.1496 29.3082 22.0093 29.3082C20.4541 29.307 18.9136 28.9165 17.5568 28.1757L16.7707 27.7473L15.9025 27.9524L13.6056 28.4947L14.1662 26.412L14.4191 25.4778L13.936 24.6392C13.1217 23.2299 12.6907 21.6185 12.6919 19.9817C12.6942 14.846 16.8747 10.6666 22.0116 10.6666ZM17.8895 14.6041C17.6947 14.6041 17.3796 14.677 17.1125 14.9687C16.8453 15.2592 16.0916 15.9628 16.0916 17.3954C16.0916 18.8281 17.1353 20.213 17.2811 20.4078C17.4258 20.6015 19.2955 23.6344 22.2554 24.801C24.7147 25.7705 25.2142 25.5792 25.7485 25.5302C26.2829 25.4824 27.4723 24.8272 27.715 24.1471C27.9577 23.4669 27.9582 22.8818 27.8859 22.7616C27.8136 22.6403 27.6193 22.568 27.3276 22.4221C27.0371 22.2763 25.6055 21.5733 25.3384 21.4765C25.0712 21.3796 24.8758 21.3306 24.6821 21.6223C24.4885 21.914 23.9319 22.568 23.7616 22.7616C23.5912 22.9565 23.422 22.9827 23.1304 22.8368C22.8387 22.6898 21.9009 22.3816 20.7879 21.3899C19.9223 20.6187 19.3381 19.6672 19.1678 19.3756C18.9986 19.0851 19.1519 18.9255 19.2977 18.7808C19.4284 18.6502 19.5871 18.4408 19.7329 18.2704C19.8776 18.1001 19.9277 17.9787 20.0246 17.7851C20.1214 17.5914 20.0718 17.4205 19.9995 17.2747C19.9272 17.1288 19.3607 15.6908 19.1017 15.1145C18.8836 14.6303 18.6531 14.6191 18.4455 14.6109C18.2763 14.6039 18.0832 14.6041 17.8895 14.6041Z"
              fill="#E2001A"
            />
          </svg>
        </button>
        <button class="share facebook" @click="share('facebook')">
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="22.0178" cy="21.9968" r="20.7322" stroke="#E2001A" stroke-width="1.2" />
            <g clip-path="url(#clip0_8554_37577)">
              <path
                d="M27.6837 10.1774C27.6837 10.1023 27.6862 10.0444 27.5894 10.0274C26.7307 9.87694 25.8725 9.70746 25.0007 9.68537C21.2862 9.41405 18.5978 11.8135 18.6093 15.8066C18.6067 16.9824 18.6037 18.1584 18.6071 19.3343C18.6075 19.4623 18.5746 19.4914 18.4566 19.4909C17.2473 19.4861 16.0381 19.4896 14.8289 19.4854C14.7184 19.485 14.6853 19.5129 14.6856 19.6333C14.6895 21.0854 14.6896 22.5376 14.6855 23.9897C14.6852 24.109 14.7149 24.1391 14.8273 24.1387C16.0365 24.1343 17.2457 24.1375 18.4549 24.1332C18.5667 24.1328 18.5975 24.163 18.5973 24.2821C18.5936 27.4096 18.5916 30.5371 18.5905 33.6645H23.3264C23.3267 30.5381 23.3296 27.4117 23.3238 24.2853C23.1026 23.8769 27.1137 24.4124 26.9519 24.0051C27.1329 22.5425 27.3178 21.0803 27.5077 19.619C27.5232 19.4996 27.4915 19.4859 27.3934 19.4861C26.0894 19.4889 24.7854 19.4865 23.4815 19.4906C23.1502 19.6411 23.3914 17.3702 23.3293 17.0443C23.347 13.8873 25.1098 13.8828 27.5502 13.9458C27.6547 13.9465 27.6859 13.9198 27.6855 13.8054C27.6814 12.5961 27.6827 11.3867 27.6837 10.1774Z"
                fill="#E2001A"
              />
            </g>
            <defs>
              <clipPath id="clip0_8554_37577">
                <rect width="13" height="24" fill="white" transform="translate(14.6855 9.66455)" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <button class="share email" @click="share('email')">
          <svg
            width="43"
            height="44"
            viewBox="0 0 43 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="21.3322" cy="21.9968" r="20.7322" stroke="#E2001A" stroke-width="1.2" />
            <rect
              x="12.8855"
              y="14.8646"
              width="17.6"
              height="13.6"
              stroke="#E2001A"
              stroke-width="2.4"
            />
            <path
              d="M30.6855 15.829L21.6855 21.329L12.5 15.5276"
              stroke="#E2001A"
              stroke-width="2.4"
            />
          </svg>
        </button>
        <button class="share copy" @click="share('copy')">
          <svg
            width="43"
            height="44"
            viewBox="0 0 43 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="21.3322" cy="21.9968" r="20.7322" stroke="#E2001A" stroke-width="1.2" />
            <path d="M14.5 11.1646H30.5V30.1646" stroke="#E2001A" stroke-width="2.4" />
            <rect
              x="11.7"
              y="15.3646"
              width="14.6"
              height="17.6"
              stroke="#E2001A"
              stroke-width="2.4"
            />
          </svg>
        </button>
      </div>
    </div>
    <div>
      <h3>{{ t('download-title') }}</h3>
      <div class="buttons">
        <button id="download" class="share" @click="printPage">
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="22.0178" cy="21.9968" r="20.7322" stroke="#E2001A" stroke-width="1.2" />
            <path
              d="M29.9541 16.1995L22.1857 23.968L14.4172 16.1995"
              stroke="#E2001A"
              stroke-width="2.4"
            />
            <line
              x1="22.0578"
              y1="22.8389"
              x2="22.0578"
              y2="9.36116"
              stroke="#E2001A"
              stroke-width="2.4"
            />
            <path
              d="M12.6855 24.6646V30.6646H31.6855V24.6646"
              stroke="#E2001A"
              stroke-width="2.4"
            />
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped>
section * {
  --color-text: var(--color-signal);
}

section {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  padding: 20px 40px;
}

h3 {
  color: var(--color-text);
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.buttons {
  display: flex;
  justify-content: flex-start;
  gap: 1.3rem;
}

button svg circle {
  stroke: var(--color-signal);
  stroke-width: 2px;
}

button.share {
  border-radius: 100%;
  border: none;
  --color-text: var(--color-signal);
  background: white;

  transition: transform 0.2s;
  aspect-ratio: 1 / 1;
  padding: 0;
}

button.share:hover {
  transform: scale(0.9);
}

.some {
  margin-right: 90px;
}

section {
  padding-top: 2rem;
  padding-bottom: 3rem;
  flex-wrap: wrap;
}
</style>
